module.exports = __webpack_public_path__ + "static/media/24.59cf0525.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/24.jpg
// module id = 199
// module chunks = 0